export { default as Header } from 'reports/components/ins_outs/InsOutsReportHeader';
export { default as Table } from 'reports/components/ins_outs/InsOutsReportTable';
export { default as Filters } from 'reports/components/ins_outs/InsOutsReportFilters';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/ins_outs/index.js